var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var ConstructionsAddFieldNames = [
    'name',
    'description',
    'priority',
    'descriptionSource',
    'country',
    'issuer',
    'maxHeight',
    'fireResistance',
    'propertySource',
    'labRTotal',
    'labIndex',
    'labIndexValue',
    'laboratoryTestSource',
];
export var ConstructionsEditFieldNames = __spreadArray(__spreadArray([], ConstructionsAddFieldNames, true), [
    'RCalcs',
    'estimatedIndexValue',
], false);
export var ConstructionTypeFieldNames = [
    'constructionType',
    'constructionTypeObject',
    'constructionTypeEnum',
    'constructions',
    'contructionPosition',
    'userMaterials',
    'materialId',
    'positionId',
    'materialTypeValue',
    'materialType',
    'value',
    'materialParameters',
];
